// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BellTwoToneSvg from "@fishx/icons-svg/es/asn/BellTwoTone";
import FishxIcon from '../components/FishxIcon';

var BellTwoTone = function BellTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BellTwoToneSvg
  }));
};

BellTwoTone.displayName = 'BellTwoTone';
export default React.forwardRef(BellTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BellTwoTone.js
// module id = 2071
// module chunks = 0